import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Standard close (X) button for the top-right of any Dialog's title bar.
 * Rendered inside a <DialogTitle> (which is position:relative by our theme).
 */
export function DialogClose({ onClose }: { onClose: () => void }) {
  return (
    <IconButton
      onClick={onClose}
      aria-label="Close"
      size="small"
      sx={{
        position: 'absolute', top: 10, right: 10,
        color: 'text.secondary',
        '&:hover': { color: 'text.primary', bgcolor: 'action.hover' },
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
}
